import { imagesBaseURL } from "constant";

export const getImageURL = (isMobile: boolean) =>
  isMobile
    ? `${imagesBaseURL}main-image-mobile.png`
    : `${imagesBaseURL}main-image.png`;
